<app-navigation *ngIf="isLoggedIn"></app-navigation>
<div class="container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>